/**
 * Pre-compiled es messages for MoneyInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  amountInputLabel: `Cantidad`,
  currencySelectLabel: `Moneda`,
  highPrecisionPrice: `Precio de alta precisión`,
};
